import I18n from './i18n';
import {loadScripts, showConsentDialog} from './Helpers';

class App {
  static availableLocales = ['he', 'en', 'de', 'fr'];

  links = {
    policy: [],
    accessibility: [],
  };

  constructor() {
    this.pixelScript = document.getElementById('tpixel');
    this.baseUrl = this.pixelScript.src.match(/https?:\/\/.*\//);
    this.tp_url = `${this.baseUrl}${this.pixelScript.dataset.p}`;

    // Parse links
    this.linkify(document.body);

    // Parse links again on dom change
    const domObserver = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type !== 'childList') continue;
        this.linkify(mutation.target);
      }
    });
    domObserver.observe(document.body, {attributes: false, childList: true, subtree: true});

    // localize links on lang change
    const localeObserver = new MutationObserver(mutationList => {
      for (const mutation of mutationList) {
        for (const a of this.links.accessibility) {
          a.textContent = this.locale.accessibilityStatement;
          a.href = this.accessibilityLink;
        }

        for (const a of this.links.policy) {
          a.textContent = this.locale.privacyPolicy;
          a.href = this.policyLink;
        }
      }
    });
    localeObserver.observe(document.documentElement, {
      attributes: true,
      childList: false,
      subtree: false,
      attributeFilter: ['lang'],
    });

    // Load pixels
    this.load();
  }

  get lang() {
    let lang = document.documentElement.lang || navigator.language || navigator.userLanguage || 'en';
    lang = lang.substring(0, 2);

    return App.availableLocales.indexOf(lang) > -1 ? lang : 'en';
  }

  get policyLink() {
    return `${this.tp_url}/${this.lang}/privacy_policy.html`;
  }

  get accessibilityLink() {
    return `${this.tp_url}/${this.lang}/accessibility_statement.html`;
  }

  get locale() {
    let locales = I18n(this.policyLink);
    return locales[this.lang] || locales.en;
  }

  linkify(elm) {
    let aTags = elm.getElementsByTagName('a');
    for (const a of aTags) {
      if (a.textContent === '__accessibility_statement__') {
        a.textContent = this.locale.accessibilityStatement;
        a.href = this.accessibilityLink;
        a.target = '_blank';
        if (this.links.accessibility.indexOf(a) < 0) this.links.accessibility.push(a);
        break;
      } else if (a.textContent === '__privacy_policy__') {
        a.textContent = this.locale.privacyPolicy;
        a.href = this.policyLink;
        a.target = '_blank';
        if (this.links.policy.indexOf(a) < 0) this.links.policy.push(a);
        break;
      }
    }
  }

  async load() {
    // load pixel
    let pixel = null;
    try {
      pixel = await fetch(`${this.tp_url}/p.json`).then(r => r.json());
    } catch (e) {
      console.error('Could not load tpixel');
      console.error(e);
      return;
    }

    if (!pixel.gdpr) loadScripts(pixel);
    else showConsentDialog(pixel, this.locale, () => loadScripts(pixel));
  }
}

export default App;

new App();
